export default "__VITE_ASSET__DwDicWGb__"